import {
  type CardFilterPartialType,
  type CardFilterType,
  isCardFilterBooleanType,
  isCardFilterColorsType,
  isCardFilterNumberType,
  isCardFilterSearchType,
  isCardFilterSelectType,
  isCardFilterType,
} from '@/defs/cardFilters'

export const cleanGalleryFilters = (cardFiltersInput?: CardFilterPartialType[]): CardFilterType[] | undefined => {
  const cardFilters = structuredClone(cardFiltersInput) ?? []

  if (cardFilters.length < 1) return

  return cardFilters
    .map((f) => {
      if (isCardFilterBooleanType(f)) return { checked: f.checked, slug: f.slug }
      if (isCardFilterColorsType(f)) return { colors: f.colors, operator: f.operator, slug: f.slug }
      if (isCardFilterNumberType(f)) return { number: f.number, operator: f.operator, slug: f.slug }
      if (isCardFilterSearchType(f)) return { search: f.search, slug: f.slug }
      if (isCardFilterSelectType(f))
        return { label: f.label, operator: f.operator, selection: f.selection, slug: f.slug }
    })
    .filter((f) => isCardFilterType(f))
}
